module.exports = __webpack_public_path__ + "img/red_048.73566a7d.png";